import { render, staticRenderFns } from "./FootBar.vue?vue&type=template&id=2e6cbe98&scoped=true&"
import script from "./FootBar.vue?vue&type=script&lang=js&"
export * from "./FootBar.vue?vue&type=script&lang=js&"
import style0 from "./FootBar.vue?vue&type=style&index=0&id=2e6cbe98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6cbe98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCard,VCardText,VFooter})
